import {
  EnvironmentProviders,
  importProvidersFrom,
  makeEnvironmentProviders,
} from '@angular/core';

import { MatDialogModule } from '@angular/material/dialog';
import { eagerProvider } from '../util';
import { PwaAppInstallerService } from './pwa-app-installer.service';
export * from './install-on-ios-instructions.component';
export * from './install-pwa.component';
export * from './pwa-app-installer.module';
export * from './pwa-app-installer.service';

export function providePwaAppInstaller(): EnvironmentProviders {
  return makeEnvironmentProviders([
    // TODO: see how dependency on mat dialog can be removed
    // to make this functionality more reusable
    importProvidersFrom(MatDialogModule),
    eagerProvider(PwaAppInstallerService),
  ]);
}
